import Filter from '../_classes/Filter';

export default function initFilter ($filters) {
	$filters.each((i, root) => {
		let $root = $(root);
		/* eslint-disable no-unused-vars */
		const filter = new Filter($root);
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/filter.js